import { DatePicker, DateView } from '@mui/x-date-pickers'
import { Dayjs } from 'dayjs'
import { CSSProperties } from 'react'
import { Control, Controller } from 'react-hook-form'

import { FORMAT, NewDate } from 'lib/helper/day'

interface Props {
  name: string
  control?: Control<any>
  format?: string
  openTo?: DateView
  views?: DateView[]
  style?: CSSProperties
  canDelete?: boolean
}

export default function KanseiDatePicker(props: Props) {
  const {
    name,
    control,
    format = 'YYYY/MM/DD (dd)',
    openTo = 'day',
    views = ['year', 'month', 'day'],
    style = {},
    canDelete = false,
  } = props

  // forでネスト構造にアクセスして、初期値を取得
  let defaultValue = control?._defaultValues
  name.split('.').forEach((x) => {
    defaultValue = defaultValue?.[x]
  })

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || null}
      render={({ field }) => {
        const { value, onChange, ref } = field
        // ここで「おかしな値」を判定する（例: 0001-01-01 なら null）
        let sanitizedValue: Dayjs | null = value ? NewDate(value) : null
        if (sanitizedValue?.format(FORMAT) === '0001-01-01') {
          sanitizedValue = null
        }
        return (
          <DatePicker
            value={sanitizedValue}
            onChange={(dateValue) => {
              onChange(dateValue)
            }}
            inputRef={ref}
            format={format}
            openTo={openTo}
            views={views}
            slotProps={
              canDelete
                ? {
                    field: { clearable: true },
                  }
                : {}
            }
            sx={style}
            className="datePicker"
          />
        )
      }}
    />
  )
}
